import { render, staticRenderFns } from "./GlobalLedgerAccounts.vue?vue&type=template&id=48e812bd&"
import script from "./GlobalLedgerAccounts.vue?vue&type=script&lang=js&"
export * from "./GlobalLedgerAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports